<template>
    <section class="container flex flex-col gap-16 w-full" :aria-labelledby="headingId">
            <h2 :id="headingId" class="view-h2 md:col-end-6 md:col-start-1 lg:col-start-2">
                {{title}}
            </h2>
            <div class="hidden md:flex md:col-start-7 md:col-span-4">
                <div class="inline-block border py-2 px-4 rounded-full md:flex md:h-fit">
                    <NuxtLink  :to="localePath(link?.url)">{{link?.label}}</NuxtLink>
                </div>
            </div>
<!--        <div class="flex flex-row place-content-between w-full col-span-full">-->
<!--        </div>-->
        <div class="col-span-full">
            <slot />
        </div>
        <div class="border py-2 px-4 rounded-full md:hidden flex items-center justify-center self-start">
            <NuxtLink  :to="localePath(link?.url)">{{link?.label}}</NuxtLink>
        </div>
    </section>
</template>

<script lang="ts" setup>
const localePath = useLocalePath()

const {title, link, headingId} = defineProps({
    title: String,
    link: Object as PropType<{url: string, label: string}>,
    headingId: String
})
</script>
